import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";

// Divider component
const Divider = () => (
  <hr className="border-t-2 border-[#FF4D00] max-w-6xl w-full mx-auto my-12 opacity-60" />
);

const AboutPage = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-800">
      <Helmet>
        <title>About | Governance & Continuity Tool</title>
      </Helmet>

      {/* About Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-5xl mx-auto text-center" data-aos="fade-up">
          <h2 className="text-4xl font-bold mb-6">About COBIT & BCM Assessments</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            This tool provides assessments for both COBIT 2019, a globally recognized framework for IT governance, and BCM (Business Continuity Management), which ensures organizations can maintain essential operations during disruptions.
          </p>
          <p className="text-lg text-gray-700 mt-6 leading-relaxed">
            By using this platform, organizations can evaluate their maturity across governance and continuity domains, track progress, identify improvement areas, and generate professional reports. Whether you are in IT, compliance, audit, or risk management, this tool streamlines assessment and reporting for both frameworks.
          </p>
          <p className="text-lg text-gray-700 mt-6 leading-relaxed">
            The tool supports evidence upload, automated scoring, progress tracking, and PDF export to ensure assessments are thorough, auditable, and actionable.
          </p>
        </div>
      </section>

      <Divider />
    </div>
  );
};

export default AboutPage;
